import { uuid } from 'uuidv4';

import type { IManagedScale, IPayScale, Qualification } from '../types';
import { orderBy } from 'shared/arrays';
import { VALID_STATES } from '../constants';

export function loadInitialScales(defaultPayScales: IPayScale[], payScales: IPayScale[]): IManagedScale[] {
    const emptyPayScales =
        !payScales?.length || payScales.every((payScale: IPayScale) => !payScale.qualifications.length);

    if (defaultPayScales.length > 0 && emptyPayScales) {
        const scales = orderBy(
            defaultPayScales.map((x: IPayScale) => ({ ...x, id: uuid() })),
            'rate',
        );

        return scales;
    }

    if (!emptyPayScales) {
        return orderBy(
            payScales.map((x: IPayScale) => ({ ...x, id: uuid() })),
            'rate',
        );
    }

    return [
        {
            id: uuid(),
            description: '15',
            rate: 15,
            qualifications: [],
        },
    ];
}

export function detectState(qualifications: Qualification[]) {
    for (const state of VALID_STATES) {
        if (qualifications.some((qualification: Qualification) => qualification.region === state)) {
            return state;
        }
    }

    return VALID_STATES[0];
}
